<template>
  <div>
    <div class="message is-info">
      <!--  <div class="message-body has-text-dark">
        <p class="is-size-4">
          A nameserver is blah blah
        </p>
      </div> -->
    </div>
    <transition-group
      name="fade"
      class="flex-body"
    >
      <div
        v-for="(ns, index) in nameservers"
        :key="ns.nameserver"
        class="notification"
      >
        <div class="level">
          <div
            class="level-item has-text-centered heading"
            :style="{flex: 1}"
          >
            {{ ns.nameserver }}
          </div>
          <div
            class="level-item"
            :style="{flex: 2, height: '77px'}"
          >
            <custom-input
              :key="index"
              v-model="ns.value"
              stop-clearfix
              :style="{width: '100%'}"
              :label-as-a-container="false"
              @blur="editNameserver(index)"
            >
              <div
                v-if="!editStatus[index]"
                :key="index"
                class="level-item has-text-centered is-size-4"
              >
                {{ ns.value }}
              </div>
            </custom-input>
          </div>
          <div class="button-pair">
            <div
              class="button-pair__button"
              @click="editNameserver(index)"
            >
              <font-awesome-icon
                role="button"
                icon="edit"
                color="var(--primary-color)"
              />
            </div>
            <div class="button-pair__button">
              <font-awesome-icon
                v-if="index === nameservers.length - 1"
                role="button"
                icon="trash"
                color="var(--primary-color)"
                :style="{ marginLeft: '10px' }"
                @click="deleteNameserver"
              />
            </div>
          </div>
        </div>
      </div>
    </transition-group>
    <div class="form-section-bg table-foot">
      <button
        class="button is-primary is-broad is-large is-uppercase"
        @click="addNameserver"
      >
        {{ $t('domains.buttons.add_nameserver') }}
      </button>
    </div>
  </div>
</template>

<script>
import CustomInput from '@/components/Shared/CustomInput'

const nsTemplate = {
  nameserver: null,
  value: null
}

export default {

  name: 'NameserverTable',
  components: {
    CustomInput
  },
  data () {
    return {
      value: '',
      nsCount: 1,
      nameservers: [
        { ...nsTemplate, nameserver: `${this.$t('domains.nameserver')} 1` }
      ],
      editStatus: [true]
    }
  },
  beforeDestroy () {
    this.$options.timer && clearTimeout(this.$options.timer)
  },
  methods: {
    setTimer () {
      // this timer prevents the editNameServer method being fired twice if the
      // user clicks the edit button at the same time as losing focus on the input
      this.$options.blockClicks = true
      this.$options.timer = setTimeout(() => {
        this.$options.blockClicks = false
      }, 200)
    },
    addNameserver () {
      this.nsCount++
      this.editStatus.push(true)
      this.nameservers.push({
        ...nsTemplate, nameserver: `${this.$t('domains.nameserver')} ${this.nsCount}`
      })
    },
    deleteNameserver () {
      this.nsCount--
      this.editStatus.pop()
      this.nameservers.pop()
    },
    editNameserver (index) {
      if (!this.$options.blockClicks) {
        this.setTimer()
        if (!this.nameservers[index].value && this.editStatus[index]) return
        this.$set(this.editStatus, index, !this.editStatus[index])
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../sass/mystyles.scss';
.heading {
  margin-bottom: 0;
}
.notification {
  background-color: var(--form-color-light) !important;
  color: black;
  padding: 0;
  margin-bottom: 5px;
}
.table-foot {
  padding: 10px 10px;
  margin-top: 5px;
}

.form-section-bg {
  background-color: var(--form-color-light);
}

.button-pair {
  justify-content: space-around;
  width: 100px;
  text-align: center;

  .button-pair__button {
    display: inline;
  }
}

@media only screen and (max-width: $break-medium) {
  .notification {
    padding: 10px !important;

  }
  .button-pair {
    justify-content: space-between;
    width: 100%;
    display: flex;

    .button-pair__button {
      display: block;
    }
  }
}

</style>
